import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { from } from 'rxjs';
import { StripeService } from 'ngx-stripe';
import { PaymentSourceService } from './payment-source.service';
import { StripeAccountType } from '../_models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankAccountConnectionService {

  constructor(
    private stripeService: StripeService,
    private paymentSourceService: PaymentSourceService
  ) {}

  connectBankAccount(accountType: StripeAccountType): Observable<any> {
    // Set the appropriate Stripe key based on account type
    if (accountType === StripeAccountType.Gateway) {
      this.stripeService.setKey(environment.stripeGatewayPublicKey);
    } else {
      this.stripeService.setKey(environment.stripePublicKey);
    }

    return this.paymentSourceService.getFinancialConnectionsSession(accountType).pipe(
      switchMap((result) => {
        const stripe = this.stripeService.getInstance();
        if (!stripe) {
          return throwError({ message: 'Stripe not initialized' });
        }

        return from(stripe.collectFinancialConnectionsAccounts({ clientSecret: result.client_secret }));
      }),
      switchMap((result) => {
        if (result.error) {
          return throwError(result.error);
        }

        if (result.financialConnectionsSession &&
            result.financialConnectionsSession.accounts &&
            result.financialConnectionsSession.accounts.length > 0) {
          const account = result.financialConnectionsSession.accounts.find((acc) => {
            return acc.status === 'active' && (acc.permissions.indexOf('payment_method') >= 0);
          });

          if (account && account.id) {
            return this.paymentSourceService.createBankAccount(account.id, accountType);
          }

          return throwError({ message: 'No payment method returned from bank connection' });
        }

        // User closed the modal without connecting an account
        return throwError({ cancelled: true });
      })
    );
  }
}
